import React from "react";

import { Container, Row, Col } from "reactstrap";
import CountUp from "react-countup";
import ScrollAnimation from "react-animate-on-scroll";

function MainStats() {
  const size =
    document.body.clientWidth >= 928 || document.documentElement.clientWidth >= 928 ? true : false;
  return (
    <div
      style={{
        background: "transparent",
      }}
      className="section py-5"
      data-parallax={true}
    >
      <Container className="">
        <Row className={"justify-content-center row-cols-2"}>
          <Col lg={3} xs={6} className="text-left align-self-center">
            {size ? (
              <h2 className="text-700 text-white m-0">ATTENDEE PROFILE</h2>
            ) : (
              <h4 className="text-700 text-white m-0">ATTENDEE PROFILE</h4>
            )}
          </Col>
          {content.map((c, index) => (
            <Col className="text-center text-white px-1" lg={3}>
              <ScrollAnimation animateIn={"fadeInUp"} animateOnce={true} duration={0.5 + index / 2}>
                <div
                  className="align-self-center pt-2 pb-4 px-1 mb-2 stat-div"
                  style={{ aspectRatio: "1/1" }}
                >
                  <h1
                    className="text-700 mb-4"
                    id="count"
                    style={{ fontSize: size ? "70px" : "40px" }}
                  >
                    <CountUp end={c.value} />
                    <small style={{ color: "#eb6700" }}>%</small>
                  </h1>
                  <h5 className="text-400 my-0" style={{ fontSize: size ? "18px" : "12px" }}>
                    {c.title}
                  </h5>
                </div>
              </ScrollAnimation>
            </Col>
          ))}
        </Row>
      </Container>
      <Container className="pt-2">
        <Row className={"justify-content-center row-cols-2"}>
          <Col lg={3} className="text-left align-self-center">
            {size ? (
              <h3 className="text-700 text-white m-0">
                Sponsors and exhibitors reaped significant
                <br />
                benefits at the 2025 Global Series:
              </h3>
            ) : (
              <h5 className="text-700 text-white m-0">
                Sponsors and exhibitors reaped significant
                <br />
                benefits at the 2025 Global Series:
              </h5>
            )}
          </Col>
          {content1.map((c, index) => (
            <Col className="text-center text-white px-1" lg={3}>
              <ScrollAnimation animateIn={"fadeInUp"} animateOnce={true} duration={0.5 + index / 2}>
                <div
                  className="align-self-center pt-2 pb-4 px-1 mb-2 stat-div"
                  style={{ aspectRatio: "1/1" }}
                >
                  <h1
                    className="text-700 my-4"
                    id="count"
                    style={{ fontSize: size ? "70px" : "40px" }}
                  >
                    <CountUp end={c.value} />
                    <small style={{ color: "#eb6700" }}>%</small>
                  </h1>
                  <h5 className="text-400 my-0" style={{ fontSize: size ? "16px" : "12px" }}>
                    {c.title}
                  </h5>
                </div>
              </ScrollAnimation>
            </Col>
          ))}
          {content2.map((c, index) => (
            <Col className="text-center text-white px-1" lg={3}>
              <ScrollAnimation animateIn={"fadeInUp"} animateOnce={true} duration={0.5 + index / 2}>
                <div
                  className="align-self-center pt-1 pb-4 px-1 mb-2 stat-div"
                  // style={{ aspectRatio: "1/1" }}
                >
                  <h1
                    className="text-700 my-4"
                    id="count"
                    style={{ fontSize: size ? "70px" : "40px" }}
                  >
                    <CountUp end={c.value} />
                    <small style={{ color: "#eb6700" }}>+</small>
                  </h1>
                  <h5 className="text-400 my-0" style={{ fontSize: size ? "16px" : "12px" }}>
                    {c.title}
                  </h5>
                </div>
              </ScrollAnimation>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default MainStats;

const content = [
  { value: "62", title: "C-Level/Directors/VPs" },
  { value: "30", title: "Heads of Digital Transformation, IT, Risk, Data & Innovation" },
  { value: "8", title: "General Managers, Senior Consultants, and Advisors" },
];

const content1 = [
  {
    value: "90",
    title: "successfully formed new connections, fostering lucrative business opportunities.",
  },
  {
    value: "76",
    title:
      "chose the event as the prime platform for product launches, gaining substantial visibility and engagement.",
  },
  {
    value: "87",
    title:
      "acknowledged the Finnovex Summit's importance for entering Middle East, Africa, and Europe markets, highlighting its strategic significance in facilitating global market access.",
  },
];

const content2 = [
  { value: "50", title: "Visionary Speakers" },
  { value: "15", title: "Hours of Insight-Driven Networking" },
  {
    value: "40",
    title: "Sponsors, Exhibitors, & Partners",
  },
  {
    value: "200",
    title: "VIP Attendees",
  },
];
